import { useAppDispatch, useAppSelector } from '~/common/stores';
import { closeAllModals, closeModal, openModal } from '~/common/stores/layout.slice.ts';

import type { ModalName } from '~/common/types/modal.type.ts';

const useModal = (modalName?: ModalName) => {
  const dispatch = useAppDispatch();

  const activeModals = useAppSelector(state => state.layout.activeModals);

  const isOpened = (targetModal?: ModalName) => {
    if (targetModal) {
      return activeModals.includes(targetModal);
    }
    if (modalName) {
      return activeModals.includes(modalName);
    }
  };

  const open = (targetModal?: ModalName) => {
    if (targetModal) {
      dispatch(openModal(targetModal));
      return;
    }
    if (modalName) {
      dispatch(openModal(modalName));
    }
  };

  const close = (targetModal?: ModalName) => {
    if (targetModal) {
      dispatch(closeModal(targetModal));
      return;
    }
    if (modalName) {
      dispatch(closeModal(modalName));
    }
  };

  const closeAll = () => {
    dispatch(closeAllModals());
  };

  return { close, closeAll, isOpened, open };
};

export default useModal;
